function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "prefix__expand",
  transform: "translate(0 -.002)"
}, React.createElement("path", {
  id: "prefix__Path_8",
  d: "M.418 3.629a.418.418 0 0 0 .418-.418V1.429L3.528 4.12a.418.418 0 1 0 .591-.591L1.427.838h1.782a.418.418 0 1 0 0-.836H.418A.418.418 0 0 0 0 .42v2.791a.418.418 0 0 0 .418.418z",
  className: "prefix__cls-1",
  "data-name": "Path 8"
}), React.createElement("path", {
  id: "prefix__Path_9",
  d: "M141.66 138.449a.418.418 0 0 0-.418.418v1.782l-2.775-2.775a.418.418 0 0 0-.591.591l2.774 2.774h-1.782a.418.418 0 1 0 0 .836h2.791a.418.418 0 0 0 .418-.418v-2.791a.418.418 0 0 0-.417-.417z",
  className: "prefix__cls-1",
  "data-name": "Path 9",
  transform: "translate(-130.078 -130.074)"
}), React.createElement("path", {
  id: "prefix__Path_10",
  d: "M3.615 137.875l-2.774 2.774v-1.782a.418.418 0 1 0-.836 0v2.791a.418.418 0 0 0 .418.418h2.791a.418.418 0 1 0 0-.836H1.432l2.774-2.775a.418.418 0 1 0-.591-.591z",
  className: "prefix__cls-1",
  "data-name": "Path 10",
  transform: "translate(-.005 -130.074)"
}), React.createElement("path", {
  id: "prefix__Path_11",
  d: "M143.071 0h-2.791a.418.418 0 0 0 0 .836h1.782l-2.691 2.691a.418.418 0 0 0 .591.591l2.691-2.691v1.784a.418.418 0 1 0 .836 0V.42a.418.418 0 0 0-.418-.42z",
  className: "prefix__cls-1",
  "data-name": "Path 11",
  transform: "translate(-131.489)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/expand.4ae4b951.svg";
export { SvgComponent as ReactComponent };